import { z } from 'zod'

const text = z.string().nullable().catch(null)
const code = z.number().int().nullable().catch(null)
const flag = z.boolean().nullable().catch(null)
const taxSchema = z.object({
    kind: z
        .enum(['with_code', 'without_code', 'mtt', 'unknown'])
        .catch('unknown'),
    source: z.enum(['cloud_status', 'unknown']).catch('unknown'),
    code,
    state: z
        .enum([
            'pending_code',
            'code_granted',
            'not_sent',
            'sent',
            'accepted',
            'rejected',
            'send_error',
            'unknown',
        ])
        .catch('unknown'),
    invoice_code_present: flag,
})
const lifecycleSchema = z.object({
    is_deleted: flag,
    reference_type: code,
    reference_role: z
        .enum(['replacement', 'adjustment', 'unknown'])
        .catch('unknown'),
})
const observationSchema = z.object({
    sales_order_id: z.string().min(1),
    invoice_id: z.string().min(1),
    draft_revision: text,
    ref_id: text,
    transaction_id: text,
    inv_series: text,
    inv_no: text,
    source: z.enum([
        'cloud_status',
        'invoiceweb_saved',
        'saved_snapshot',
        'persisted_issued',
    ]),
    observed_at: z.iso.datetime({ offset: true }).nullable().catch(null),
    publication: z
        .enum(['draft', 'processing', 'published', 'failed', 'unknown'])
        .catch('unknown'),
    publication_code: code,
    tax: taxSchema.catch(() => taxSchema.parse({})),
    document_kind: z
        .enum(['saved_draft', 'published', 'unknown'])
        .catch('unknown'),
    document_available: z.boolean().catch(false),
    lifecycle: lifecycleSchema.catch(() => lifecycleSchema.parse({})),
})

export type EInvoiceObservation = z.infer<typeof observationSchema>

export function parseEInvoiceObservation(
    value: unknown,
    orderId: string,
): EInvoiceObservation | null {
    try {
        const parsed = observationSchema.safeParse(
            typeof value === 'string' ? JSON.parse(value) : value,
        )
        return parsed.success && parsed.data.sales_order_id === orderId
            ? parsed.data
            : null
    } catch {
        return null
    }
}
